export enum product {
    term = 'Term',
    intraday = 'Intraday',
    daily = 'Daily',
    seasonal = 'seasonal',
    yearly = 'Yearly',
    quarterly = 'Quarterly',
    monthly = 'Monthly',
    weekly = 'Weekly',
    weekend = 'Weekend',
    all = 'All',
  }

  export enum showHide {
    show = 'Show',
    hide = 'Hide'
  }